// Applicant "Type of Business" options, shared by the Company Info page and the
// R&R Cover section of the grant questionnaire. Values are stored as the full
// "<letter>: <label>" string so saved answers stay readable in the CSVs.
export const BUSINESS_TYPE_OPTIONS = [
  'A: State Government',
  'B: County Government',
  'C: City or Township Government',
  'D: Special District Government',
  'E: Regional Organization',
  'F: U.S. Territory or Possession',
  'G: Independent School District',
  'H: Public/State Controlled Institution of Higher Education',
  'I: Indian/Native American Tribal Government (Federally Recognized)',
  'J: Indian/Native American Tribal Government (Other than Federally Recognized)',
  'K: Indian/Native American Tribally Designated Organization',
  'L: Public/Indian Housing Authority',
  'M: Nonprofit with 501C3 IRS Status (Other than Institution of Higher Education)',
  'N: Nonprofit without 501C3 IRS Status (Other than Institution of Higher Education)',
  'O: Private Institution of Higher Education',
  'P: Individual',
  'Q: For-Profit Organization (Other than Small Business)',
  'R: Small Business',
  'S: Hispanic-serving Institution',
  'T: Historically Black Colleges and Universities (HBCUs)',
  'U: Tribally Controlled Colleges and Universities (TCCUs)',
  'V: Alaska Native and Native Hawaiian Serving Institutions',
  'W: Non-domestic (non-US) Entity',
  'X: Other (specify)'
];

export const DEFAULT_BUSINESS_TYPE = 'R: Small Business';
export const SMALL_BUSINESS_TYPE = 'R: Small Business';
export const OTHER_BUSINESS_TYPE = 'X: Other (specify)';

export const ZIP_LOOKUP_URL = 'https://tools.usps.com/zip-code-lookup.htm?byaddress';
export const CONGRESSIONAL_DISTRICT_URL = 'https://www.house.gov/representatives/find-your-representative';

// Fallback signing official phone number, used until a company enters its own.
// Shared so the Company Info page and the grant questionnaire agree.
export const DEFAULT_SO_PHONE = '484-416-0113';

// ZIP is five digits, optionally with the four-digit extension.
export const ZIP_PATTERN = /^\d{5}(-\d{4})?$/;
// Congressional districts are written state-district, e.g. CA-012.
export const CONGRESSIONAL_DISTRICT_PATTERN = /^[A-Za-z]{2}-\d{2,3}$/;

export const isValidZip = (value) => !String(value || '').trim() || ZIP_PATTERN.test(String(value).trim());
export const isValidCongressionalDistrict = (value) =>
  !String(value || '').trim() || CONGRESSIONAL_DISTRICT_PATTERN.test(String(value).trim());
